const __version__ ='lsi_v1.0'

module.exports = {
    __version__
}

